import { ContentType } from '@insided/shared/utils/contentType'
import { Author } from '../../interfaces'
import Approve from '../Approve'
import Button from '@insided/control/uikit/Button'

/* eslint-disable import/no-internal-modules */
import EscalationOptions from '../../Escalation/EscalationOptions'
import { MoveToTopic } from '../../MoveToTopic'
import { ConfigContext } from '../../utils'

export interface ReplyActionsProps {
  topicId: number
  id: string
  contentType: ContentType
  spam: boolean
  author: Author
  title?: string
  topicTitle: string
  moderatorId?: string
  content: string | null
  trashed: boolean
  pending: boolean
  isReply?: boolean
  destinationUrl: string
  userId?: string
  isProductboardNoteCreationEnabled: boolean
  isSalesforceCaseEscalationEnabled: boolean
  isZendeskTicketEscalationEnabled: boolean
  isFreshdeskTicketEscalationEnabled: boolean
  onToggleTrash: (show: boolean) => void
  onShowEditor: () => void
  onApprove?: () => void
  onToggleSpam: (id: string) => void
  handleTrash: () => void
  onShowAlert: (type: 'success' | 'error', message?: string) => void
  onSelectReply: (selectedReplyId: string) => void
  selected: boolean
  getReplies: (page?: number, pageSize?: number, sort?: string) => Promise<any>
  publicId?: string
}

const ReplyActions = ({ id, spam, content, onToggleTrash, onShowEditor, userId, moderatorId, author, onApprove, onShowAlert, onToggleSpam, topicTitle, destinationUrl, topicId, contentType, trashed, isProductboardNoteCreationEnabled, isSalesforceCaseEscalationEnabled, isZendeskTicketEscalationEnabled, isFreshdeskTicketEscalationEnabled, pending, handleTrash, onSelectReply, selected, getReplies, publicId }: ReplyActionsProps) => {
  return (
    <ConfigContext.Consumer>
      {({ contentTypeConfig }) => {
        return (
          <div className='post__panel-footer--action-box js-post-panel-footer-action-box'>
            <div className='post__panel-footer--action-box_actions'>
              {!trashed && !spam && <Button
                title='Edit post'
                variant='secondary'
                onClick={onShowEditor}
                data-qa='edit-post'
                                    />}
              <EscalationOptions
                isZendeskTicketEscalationEnabled={isZendeskTicketEscalationEnabled}
                isProductboardNoteCreationEnabled={isProductboardNoteCreationEnabled}
                isSalesforceCaseEscalationEnabled={isSalesforceCaseEscalationEnabled}
                isFreshdeskTicketEscalationEnabled={isFreshdeskTicketEscalationEnabled}
                trashed={trashed}
                userId={userId ?? ''}
                username={author.username}
                publicId={parseInt(id)}
                moderatorId={moderatorId ?? ''}
                title={topicTitle}
                content={content}
                contentType={contentType}
                isReply
                destinationUrl={destinationUrl}
                topicId={topicId}
              />

              {contentTypeConfig.moveReplyToExistingTopic && !spam && !trashed &&
                <MoveToTopic
                  contentType={contentType}
                  replyId={id}
                  onShowAlert={onShowAlert}
                  getReplies={getReplies}
                  publicId={publicId}
                />}

              {!trashed && <Button
                title={spam ? 'Mark as not spam' : 'Mark as spam'}
                variant={spam ? 'secondary' : 'warning'}
                className={spam ? 'qa-mark-as-not-spam' : 'qa-mark-as-spam'}
                onClick={() => onToggleSpam(id)}
                           />}

              {!spam && <Button
                title={trashed ? 'Restore' : 'Trash'}
                variant={trashed ? 'secondary' : 'warning'}
                className={trashed ? 'qa-restore-reply' : 'qa-trash-reply'}
                onClick={trashed ? () => handleTrash() : () => onToggleTrash(true)}
                        />}

              {pending && onApprove && <Approve
                replyId={parseInt(id)}
                contentType={contentType}
                onApprove={onApprove}
                onShowAlert={onShowAlert}
                                       />}
            </div>

            <div>
              {!trashed && !spam && <input
                data-qa='multi-select-reply'
                type='checkbox'
                className='pull-right'
                checked={selected}
                onChange={() => {
                  onSelectReply(id)
                }}
                                    />}
            </div>
          </div>
        )
      }}
    </ConfigContext.Consumer>
  )
}

export default ReplyActions
